import { postJson, secureFetch, secureGetJson, securePostJson } from "./MyFetch"

export interface UserDTO {
    id:number
    firstName:string
    lastName:string
    email:string
    roles:string
    status:string
    deleted:string
    bio:string
    avatarFile:number
}

export function hasRole(user:UserDTO, role:string):boolean {
    return user.roles.split(',').map(s => s.trim()).includes(role);
}

export async function getCurrentUser():Promise<UserDTO> {
    return secureGetJson('/api/users/current');
}

export async function getUserById(id:number):Promise<UserDTO> {
    return secureGetJson(`/api/users/${id}`);
}

export async function getUsers():Promise<UserDTO[]> {
    return secureGetJson(`/api/users`);
}

export interface NewUser {
    email:string
}

export async function newUser(req:NewUser):Promise<UserDTO> {
    return securePostJson(`/api/users/new`, req);
}

export async function updateUser(user:UserDTO):Promise<UserDTO> {
    return securePostJson(`/api/users`, user);
}

export interface LoginResultDTO {
    user:UserDTO
    success:boolean
    jwt:string
    refreshToken:string
    details:string
}

export async function loginUser(username:string, password:string):Promise<LoginResultDTO> {
    return postJson('/api/login', {login:username, password:password});
}

export interface DeleteUserResponse {
    Deleted:number
}

export async function deleteUsers(ids:Set<Number>):Promise<DeleteUserResponse> {
    return securePostJson('/api/users/delete', {ids:[...ids]});
}

export interface UpdateAvatarResponse {
    Id:number
}

export async function updateAvatar(file):Promise<UpdateAvatarResponse> {
    const formData = new FormData();
    formData.append('file', file);
    const opts = {
        method: "POST",
        body: formData
    };
    return secureFetch('/api/users/avatar', opts);
}

export interface LoginByTokenRequest {
    token:string
}

export async function loginByRegisterToken(req:LoginByTokenRequest):Promise<LoginResultDTO> {
    return postJson('/api/loginByRegisterToken', req);
}

export async function loginByResetPasswordToken(req:LoginByTokenRequest):Promise<LoginResultDTO> {
    return postJson('/api/loginByResetPasswordToken', req);
}

export interface RegisterRequest {
    firstName:string
    lastName:string
    email:string
    password:string
    token:string
}

export async function registerUser(req:RegisterRequest):Promise<LoginResultDTO> {
    return postJson('/api/register', req);
}

export interface ChangePasswordRequest {
    password:string
    token:string
}

export async function changePassword(req:ChangePasswordRequest):Promise<LoginResultDTO> {
    return postJson('/api/change-password', req);
}

export interface ResetPasswordEmail {
    email:string
}

export async function resetPasswordEmail(req:ResetPasswordEmail):Promise<string> {
    return postJson('/api/resetPasswordEmail', req);
}
